import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PrettyJsonModule} from 'angular2-prettyjson';
import{ CalendarComponent} from '../../../common/component/calendar/calendar.component';


@NgModule({
  imports: [
    CommonModule
    ,PrettyJsonModule
  ],
  declarations: [CalendarComponent],
  exports: [CalendarComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CalendarModule { }
